import { instance } from '@/libs/api/instance'

/**
 * @param {string} cardId
 * @param {{ requestId: string, status: 'Success'|'Rejected', type: '3ds' }} payload
 */
export const respondOob = (cardId, payload) => {
  return instance.post(`/v1/card/${cardId}/oob`, payload)
}
